import React from 'react'
import PropTypes from 'prop-types'
import { getI18n } from 'client/i18n'
import cssModules from 'react-css-modules'
import styles from './create_disclaimer.less'

const COUNTRY_CODE_DEFAULT = 'US'

const i18n = getI18n('components/pages/create/pool_publish')

class CreateDisclaimer extends React.Component {
  static propTypes = {
    countryCode: PropTypes.string,
  }

  static defaultProps = {
    countryCode: COUNTRY_CODE_DEFAULT,
  }

  render() {
    let { countryCode } = this.props

    const privacyPolicyLink = `/${countryCode}/webapps/mpp/ua/privacy-full`

    const termsAndConditionLink = '/pools/terms'

    return (
      <p
        styleName="content"
        dangerouslySetInnerHTML={{
          __html: i18n('disclaimer', {
            tc_link: termsAndConditionLink,
            pp_link: privacyPolicyLink,
          }),
        }}
      />
    )
  }
}

export default cssModules(CreateDisclaimer, styles)
